module.exports = __webpack_public_path__ + "media/images/bg-wave-outline-625a2551982fc15182e6155c25a17608.svg";